import styled, { css } from 'styled-components'

interface TTypeContent {
  typeContent?: string
}

export const Container = styled.footer<TTypeContent>`
  position: sticky;
  bottom: 0;
  display: flex;
  width: 100%;
  border-top: 1px solid #dddddd;

  background: rgb(${({ theme }) => theme.excerpt.high});
  ${(props) =>
    props.typeContent === 'Video' &&
    css`
      border-top: 1px solid rgb(34, 34, 34);
    `}
`

export const NavigationWrapper = styled.div<TTypeContent>`
  width: 100%;
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;

  background: rgb(${({ theme }) => theme.excerpt.high});
  ${(props) =>
    props.typeContent === 'Video' &&
    css`
      background: rgb(34, 34, 34);
      color: rgb(249, 249, 249);
    `}

  .iconLeft {
    padding-left: 15px;
  }

  .iconRight {
    padding-right: 15px;
  }

  .last {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 280px;
    height: 80px;
    gap: 6px;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
    text-align: initial;
  }

  .textLeft {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
    text-align: left;
  }

  .textRight {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
    text-align: initial;
  }

  button {
    display: flex;
    align-items: center;
    max-width: 190px;
    height: 60px;
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    ${(props) =>
      props.typeContent === 'Video' &&
      css`
        color: rgb(249, 249, 249);

        svg {
          color: rgb(249, 249, 249) !important;
        }
      `}
  }

  .left {
    justify-content: flex-start;
    gap: 10px;
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 6px;
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (min-width: 800px) {
    button {
      max-width: none;
    }
  }
`
